// extracted by mini-css-extract-plugin
module.exports = {"textImgA1":"textImgA1_textImgA1__2lMk0"};